import React from 'react';
import type { PropsWithChildren } from 'react';
import type { MarginProps } from 'styled-system';

import { Text as BaseText, Heading } from 'common/components/Text';
import type { TextProps as BaseTextProps } from 'common/components/Text';
import type { AsProps } from 'common/theme/system-utilities';

type TextProps = BaseTextProps & AsProps & MarginProps & PropsWithChildren;

const styledTitleStyles: TextProps = {
  as: 'h1',
  m: 'sp_0',
  mb: 'sp_16',
  color: 'sys.neutral.text.strong',
  fontSize: ['fs_20', null, 'fs_24', 'fs_28'],
  lineHeight: ['lh_28', null, 'lh_32', 'lh_36'],
};

const styledTextStyles: TextProps = {
  as: 'p',
  m: 'sp_0',
  mb: ['sp_20', 'sp_16'],
  textAlign: ['left', 'center'],
  color: 'sys.neutral.text.strong',
  fontSize: ['fs_16', null, null, 'fs_18'],
  lineHeight: ['lh_24', null, null, 'lh_28'],
};

export const Title = ({ children }: TextProps) => (
  <Heading {...styledTitleStyles}>{children}</Heading>
);

export const Text = ({ children, ...marginProps }: TextProps) => (
  <BaseText {...styledTextStyles} {...marginProps}>
    {children}
  </BaseText>
);
